import { colors } from 'constants/colors';
import { DeliveryState } from 'data/__generated__';

export const DELIVERY_STATES_LABELS = {
    [DeliveryState.Aborted]: 'Annulée',
    [DeliveryState.Archived]: 'Archivée',
    [DeliveryState.Created]: 'Créée',
    [DeliveryState.Delivered]: 'Livrée',
    [DeliveryState.InProgress]: 'En livraison',
    [DeliveryState.Paused]: 'En pause',
    [DeliveryState.NotDelivered]: 'Non livrée',
    [DeliveryState.Packaging]: 'En préparation',
    [DeliveryState.Ready]: 'Prête',
};

export const DELIVERY_PLURAL_STATES_LABELS = {
    [DeliveryState.Aborted]: 'Annulées',
    [DeliveryState.Archived]: 'Archivées',
    [DeliveryState.Created]: 'Créées',
    [DeliveryState.Delivered]: 'Livrées',
    [DeliveryState.InProgress]: 'En livraison',
    [DeliveryState.Paused]: 'En pause',
    [DeliveryState.NotDelivered]: 'Non livrées',
    [DeliveryState.Packaging]: 'En préparation',
    [DeliveryState.Ready]: 'Prêtes',
};

export const getColorsFromState = (state: DeliveryState) => {
    const { blue, green, pantinGrey, lightGrey, black, yellow, red, pureWhite } = colors;

    switch (state) {
        case DeliveryState.Aborted:
            return { backgroundColor: red, labelColor: pureWhite };
        case DeliveryState.Archived:
            return { backgroundColor: pantinGrey, labelColor: pureWhite };
        case DeliveryState.Created:
            return { backgroundColor: lightGrey, labelColor: black };
        case DeliveryState.Delivered:
            return { backgroundColor: green, labelColor: black };
        case DeliveryState.InProgress:
            return { backgroundColor: blue, labelColor: pureWhite };
        case DeliveryState.Paused:
            return { backgroundColor: pantinGrey, labelColor: pureWhite };
        case DeliveryState.NotDelivered:
            return { backgroundColor: pantinGrey, labelColor: pureWhite };
        case DeliveryState.Packaging:
            return { backgroundColor: black, labelColor: pureWhite };
        case DeliveryState.Ready:
            return { backgroundColor: yellow, labelColor: black };
    }
};
